import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatedMoney } from '../slices/WalletSlice';
import { buildAuthenticatedEventSourceUrl } from '../helper/Constants';

const SSEListener = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.wallet.userId);

  useEffect(() => {
    if (!userId) return;

    const eventSourceUrl = buildAuthenticatedEventSourceUrl(
      `api/balance-updates/${userId}`
    );
    if (!eventSourceUrl) return;

    const eventSource = new EventSource(eventSourceUrl);

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data?.balance === undefined) {
        return;
      }

      if (data?.userId && String(data.userId) !== String(userId)) {
        return;
      }

      dispatch(updatedMoney(data.balance));
    };

    eventSource.onerror = (error) => {
      console.error('SSE error:', error);
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, [dispatch, userId]);

  return null; // This component doesn't render anything
};

export default SSEListener;
